import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";
import moment from "moment";
import { Event } from "^/Objs/EventPage/EventList";

function EventsBlock({ widget, siteId }) {
  const eventCount = widget.get("eventCount") || 5;
  const eventsPage = widget.get("eventLink");
  const currentHour = moment().startOf("day").toDate();
  const events = Scrivito.Obj.onSite(siteId)
    .where("_objClass", "equals", "EventPage")
    .andNot("endDate", "isLessThan", currentHour)
    .order("date", "asc")
    .take(eventCount);

  return (
    <div className="col-sm-4">
      <Scrivito.ContentTag
        tag="h3"
        content={widget}
        attribute="eventHeadline"
      />
      {events.reverse().map((event, index) => (
        <Event event={event} key={index} className="" />
      ))}
      {eventsPage && (
        <Scrivito.LinkTag
          to={eventsPage}
          className="btn btn-sm btn-outline-primary"
        >
          {I18n.t("Event all events")}
        </Scrivito.LinkTag>
      )}
    </div>
  );
}
export default Scrivito.connect(EventsBlock);
